// Handles showing and hiding tabs on account/products.
(function() {
  var snAccountProductsModule = function () {
    var self = this;

    return {
      init: function() {
        self = this;
        self.activeList = document.getElementById('active-list');
        self.wantsList = document.getElementById('wants-list');
        self.completedList = document.getElementById('completed-list');
        self.promocodesList = document.getElementById('promocodes-list');
        self.activeTabMobile = document.getElementById('active-tab-mobile');
        self.wantsTabMobile = document.getElementById('wants-tab-mobile');
        self.completedTabMobile = document.getElementById('completed-tab-mobile');
        self.promocodesTabMobile = document.getElementById('promocodes-tab-mobile');
        self.activeTabDesktop = document.getElementById('active-tab-desktop');
        self.wantsTabDesktop = document.getElementById('wants-tab-desktop');
        self.completedTabDesktop = document.getElementById('completed-tab-desktop');
        self.promocodesTabDesktop = document.getElementById('promocodes-tab-desktop');

        var currentTab = self._getTabFromQueryString();
        switch (currentTab) {
          case 'Active':
          case 'Wants':
          case 'Completed':
          case 'PromoCodes':
            self._activateTab(currentTab);
            break;
          default:
            self._activateTab('Active');
            break;
        }

        self._setupClicks();
      },

      _getTabFromQueryString: function() {
        var qs = window.location.search;
        var regex = /[?&]tab=([^&]*)/;
        var tab = regex.exec(qs);
        if (tab && tab[1]) {
          return(tab[1]);
        }
        return "";
      },
      
      _setupClicks: function() {
        self.activeTabMobile.onclick = function() {
          self._activateTab("Active");
        };
        self.wantsTabMobile.onclick = function() {
          self._activateTab("Wants");
        };
        self.completedTabMobile.onclick = function() {
          self._activateTab("Completed");
        };
        self.promocodesTabMobile.onclick = function() {
          self._activateTab("PromoCodes");
        };
        self.activeTabDesktop.onclick = function() {
          self._activateTab("Active");
        };
        self.wantsTabDesktop.onclick = function() {
          self._activateTab("Wants");
        };
        self.completedTabDesktop.onclick = function() {
          self._activateTab("Completed");
        };
        self.promocodesTabDesktop.onclick = function() {
          self._activateTab("PromoCodes");
        };
      },

      _reset: function() {
        self.activeTabMobile.classList.remove('active');
        self.wantsTabMobile.classList.remove('active');
        self.completedTabMobile.classList.remove('active');
        self.promocodesTabMobile.classList.remove('active');
        self.activeTabDesktop.classList.remove('active');
        self.wantsTabDesktop.classList.remove('active');
        self.completedTabDesktop.classList.remove('active');
        self.promocodesTabDesktop.classList.remove('active');
        self.activeList.style.display = "none";
        self.wantsList.style.display = "none";
        self.completedList.style.display = "none";
        self.promocodesList.style.display = "none";
      },

      _activateTab: function(tab) {
        self._reset();
        switch (tab) {
          case 'Active':
            self.activeTabMobile.classList.add('active');
            self.activeTabDesktop.classList.add('active');
            self.activeList.style.display = "block";
            break;
          case 'Wants':
            self.wantsTabMobile.classList.add('active');
            self.wantsTabDesktop.classList.add('active');
            self.wantsList.style.display = "block";
            break;
          case 'Completed':
            self.completedTabMobile.classList.add('active');
            self.completedTabDesktop.classList.add('active');
            self.completedList.style.display = "block";
            break;
          case 'PromoCodes':
            self.promocodesTabMobile.classList.add('active');
            self.promocodesTabDesktop.classList.add('active');
            self.promocodesList.style.display = "block";
            break;
        }
      }
    };

  }();

  if (typeof module !== 'undefined' && typeof module.exports !== 'undefined') {
    module.exports = snAccountProductsModule;
  } else {
    window.snAccountProductsModule = snAccountProductsModule;
  }

})();
